import React, { memo } from 'react';
import { animated, easings, useTransition } from 'react-spring';

import Backdrop from '@/components/atomic/atoms/data-display/badge/backdrop';
import Styled from '@/components/atomic/atoms/data-display/badge/styled';
import type { ViewProps } from '@/components/atomic/atoms/layout/view/typings';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const AnimatedBackdrop = animated(Backdrop);

const BadgeComponent: React.FC<ViewProps & BasicComponentProps> = ({
	children,
	...props
}) => {
	const transitions = useTransition(children, {
		from: { transform: 'scale3d(1.5, 1.5, 1.5)' },
		enter: { transform: 'scale3d(1, 1, 1)' },
		leave: { transform: 'scale3d(1, 1, 1)' },
		config: { duration: 800, easing: easings.easeInOutCirc },
	});

	return (
		<Styled {...props}>
			{transitions((style, item) =>
				item ? <AnimatedBackdrop style={style} /> : null,
			)}
			<small>{children}</small>
		</Styled>
	);
};

const Badge = memo(withExposer(BadgeComponent, 'badge'));

export default Badge;
